module.exports = __webpack_public_path__ + "static/media/warning-emoji.76153e9d.png";